<script lang="ts">
  import { page } from '$app/stores';
  import { getFlagEmoji } from '$utils/geo';
  import { isRaceClosed } from '$utils/race';
  import { calculateTimeToJump, currentTime } from '$utils/time';
  import TablerClock from '~icons/tabler/clock';
  import PhClockAfternoonDuotone from '~icons/ph/clock-afternoon-duotone';
  $: ({ race } = $page.data);

  // TODO this is breaking the layout
  $: ttj = '';
  $: {
    if ($currentTime && $race && !isRaceClosed($race)) {
      const diff = calculateTimeToJump($race.startTime, $currentTime);
      // prepend 'in ' if diff is positive
      if ($race?.startTime && $race?.startTime > $currentTime) {
        ttj = `in ${diff}`;
      } else {
        ttj = diff ?? '';
      }
    } else {
      ttj = '';
    }
  }

  // class to style the ttj text if it is less than 2 minutes
  $: ttjClass = () => {
    if (!$race?.startTime) return '';
    // get diff in seconds
    const diff = ($race.startTime.getTime() - $currentTime.getTime()) / 1000;
    if (diff && diff < 0) {
      return 'text-red-700';
    }
    if (diff && diff < 120) {
      return 'text-orange-700';
    }
    return '';
  };
</script>

<div class="z-[22] hidden flex-row border-b border-gray-300 md:flex">
  <div class="flex grow flex-row bg-gray-100 text-xs text-black md:text-sm">
    {#if $race}
      <div class="flex grow flex-row items-center md:m-1">
        <div
          class="justify-end pl-2 font-semibold {ttjClass()} flex items-center text-lg"
        >
          {#if ttj}
            <TablerClock class="mr-2 h-4 w-4" />
            {ttj}
          {/if}
        </div>
      </div>
      <div class="flex flex-row items-center py-1">
        <span class="mr-2 border-r-stone-200 font-semibold">
          {$race.meeting.type}
        </span>
        <span class="mr-2 hidden border-r-stone-200 text-gray-600 md:block">
          {$race?.name}
        </span>
        {#if $race?.distance}
          <span class="mr-2 border-r-stone-200">
            {$race?.distance}m
          </span>
        {/if}
        <span class="mr-2 border-r-stone-200">
          {getFlagEmoji($race.meeting.location)}
          {$race.meeting?.location}
        </span>
        <!-- <div
          class="flex flex-row bg-slate-700 rounded-l-md hover:bg-slate-800 items-center p-2 gap-x-1 text-gray-50 cursor-pointer"
        >
          <TablerListDetails class="w-4 h-4" />
          <span>Race Settings</span>
        </div> -->
      </div>
    {/if}
  </div>
</div>
